import axios from 'axios';
import React, {useState, useEffect} from 'react';
import { Button, FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '../util/webService'
import {encodeParams, getAction} from '../util/helper'
import { setCodeGroups } from '../redux/actions/codeGroupAction';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { setCodes } from '../redux/actions/codeAction';

const Row = props => {
  const codeGroupId = props.codeGroupId
  const [record, setRecord] = useState({
    id: -1,
    codeGroupId: codeGroupId,
    code: '',
    name:'',
    sqNum: '',
    remark: ''
  })
  const dispatch = useDispatch()
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)

  const onChange = (field, e) => {
    const newRecord = {...record}
    newRecord[field] = e.target.value
    
    setRecord(newRecord)
  }

  const onCreate = async() => {
    const url = '/code'
    const action = getAction(url, {})
    const params = {record: JSON.stringify(record)}
    const resp = await WebService.post(action, params)
    
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const newCodes = JSON.parse(repMessage.records)
      dispatch(setCodes(newCodes))
    }
  }

  return (
    <div style={{flexDirection:'row', display:'flex', alignItems:'center'}}>
      <div style={{padding:10}}>
        <input type='number' placeholder='순서' value={record.sqNum} onChange={(e) => {onChange('sqNum', e)}}/>
      </div>
      <div style={{padding:10}}>
        <input type='text' placeholder='코드명' value={record.name} onChange={(e) => {onChange('name', e)}} />
      </div>
      <div> <button onClick={async () => {onCreate()} }>추가</button> </div>
    </div>
  )
}

const CodePage = () => {
  const defUrl = '/code'
  const [record, setRecord] = useState({})

  // redux
  const dispatch = useDispatch()
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)

  useEffect(() => {
    // onLoad()
  }, [])

  const onChange = (id, field, e) => {
    const newCodes = [...codes]
    const found = newCodes.find(d => d.id === id)
    if(found) {
      
      found[field] = e.target.value
      dispatch(setCodes(newCodes))
    }
  }

  const onUpdate = async(id) => {
    const url = defUrl
    const found = codes.find(d => d.id === id)
    if(found) {
      const params = {record: JSON.stringify(found)}
      const action = getAction(url, {})
      const resp = await WebService.post(action, params)

    }
    
    // Alert.alert('알림', resp.repMessage, [{text: '확인'}]);
  }

  const onDelete = async(codeGroupId, id) => {
    const url = defUrl
    const nameValue = {codeGroupId: codeGroupId, id: id, }
    const action = getAction(url, nameValue)
    const resp = await WebService.delete(action)
    if(resp.repCode === 'ack') {
      const newCodes = [...codes]
      const found = newCodes.find(d => d.id === id)
      const idx = newCodes.indexOf(found)
      newCodes.splice(idx, 1)
      dispatch(setCodes(newCodes))
    }
    // Alert.alert('알림', resp.repMessage, [{text: '확인'}]);
  }


  

  

  return (
    <div style={{padding:100}}>
      <h1>코드관리</h1>
      <div>
        {codeGroups.map(d => {
          return(
            <div>
              <div style={{flexDirection:'row', display:'flex'}}>
                <div style={{padding:10}}>{d.remark}</div>
                <div style={{padding:10}}>{d.id}</div>
                <div style={{padding:10}}>{d.name}</div>
                <div style={{padding:10}}>{d.tblName}</div>
                <div style={{padding:10}}>{d.colName}</div>
              </div>
              <Row codeGroupId={d.id} />
              <div>
                <table>
                  <thread>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </thread>
                  <tbody>
                    {codes.filter(d2 => d2.codeGroupId === d.id).map(d3 => {
                      return(
                        <tr>
                          <td><input type='text' value={d3.sqNum} onChange={(e) => {onChange(d3.id, 'sqNum', e)}}/></td>
                          <td>{d3.code}</td>
                          <td><input type='text' value={d3.name} onChange={(e) => {onChange(d3.id, 'name', e)}}/></td>
                          <td>{d3.remark}</td>
                          <td><button onClick={() => onUpdate(d3.id)}>저장</button></td>
                          <td><button onClick={() => onDelete(d.id, d3.id)}>삭제</button></td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
}

export default CodePage
